import { render, staticRenderFns } from "./t-orm-simple-data-item.vue?vue&type=template&id=dd2c916c&scoped=true&lang=pug&"
import script from "./t-orm-simple-data-item.vue?vue&type=script&lang=js&"
export * from "./t-orm-simple-data-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2c916c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
